import type {OrganizationUserData} from '../OrganizationUserCard/types';

import type {FetchUserFactoryOptions} from './types';

export function fetchUserFactory({route, cacheTTL, getUserId, onError}: FetchUserFactoryOptions) {
    return function fetchUser(anchor: HTMLElement) {
        const user = anchor.dataset.user;

        if (user) {
            try {
                const userData: OrganizationUserData = JSON.parse(user);
                const timestamp = parseInt(String(anchor.dataset.userTimestamp), 10);

                const canUseSerializedData =
                    Number.isNaN(timestamp) ||
                    typeof cacheTTL !== 'number' ||
                    Date.now() - timestamp <= cacheTTL;

                if (canUseSerializedData) {
                    return Promise.resolve(userData);
                }
            } catch (error) {
                if (onError) {
                    onError({code: 'user_data_parse_error', error, user});
                }
                return Promise.resolve(null);
            }
        }

        if (!route) {
            return Promise.resolve(null);
        }

        const userId = getUserId && getUserId(anchor);
        const fetchRoute = route.replace(/\{userId\}/g, userId || '');

        return fetch(fetchRoute, {credentials: 'include'})
            .then((res) => {
                if (!res.ok) {
                    if (onError) {
                        onError({
                            code: 'user_data_response_error',
                            requestUrl: fetchRoute,
                            status: res.status,
                            userId,
                        });
                    }
                    return null;
                }
                return res.json();
            })
            .then((userData: OrganizationUserData) => {
                if (userData) {
                    anchor.dataset.user = JSON.stringify(userData);
                    anchor.dataset.userTimestamp = String(Date.now());
                }
                return userData;
            })
            .catch((error) => {
                if (onError) {
                    onError({
                        code: 'user_data_fetch_error',
                        requestUrl: fetchRoute,
                        error,
                        userId,
                    });
                }
                return null;
            });
    };
}
